import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";
import { Category, CloseCircle, InfoCircle } from "iconsax-react";
import MobileLayout from "../../../components/MobileLayout";
import {
  SelectionHeader,
  SelectionCard,
  InfoTooltip,
  LetterGrid,
  LetterCard,
  LibrasModalContent,
  LibrasCircle,
  CategoriesEntry,
} from "./styles";

const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

const LetterSelection: React.FC = () => {
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedLetter, setSelectedLetter] = useState<string | null>(null);

  const handleLetterClick = (letter: string) => {
    navigate("/sinalario/list", { state: { letter } });
  };

  const handleLongPress = (letter: string) => {
    setSelectedLetter(letter);
    setModalVisible(true);
  };

  return (
    <MobileLayout headerTitle="Sinalário" headerType="private">
      <SelectionHeader>
        <SelectionCard>
          <h2>Selecione uma letra</h2>
          <p>Escolha a letra que deseja visualizar os sinais</p>
          <InfoTooltip>
            <InfoCircle size={16} color="#FFFFFF" />
            <span>Segure uma letra para ver o sinal em Libras</span>
          </InfoTooltip>
        </SelectionCard>
        <CategoriesEntry
          type="button"
          onClick={() => navigate("/sinalario/categories")}
        >
          <Category size={20} variant="Bold" color="#5F33E1" />
          <span>Explorar por categorias</span>
        </CategoriesEntry>
      </SelectionHeader>

      <LetterGrid>
        {ALPHABET.map((letter) => (
          <LetterCard
            key={letter}
            onClick={() => handleLetterClick(letter)}
            onContextMenu={(e) => {
              e.preventDefault();
              handleLongPress(letter);
            }}
            title="Clique para ver palavras, clique com botão direito para ver em Libras"
          >
            <span>{letter}</span>
          </LetterCard>
        ))}
      </LetterGrid>

      <Modal
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        closeIcon={<CloseCircle size={24} color="#1E293B" />}
        centered
        width={350}
      >
        <LibrasModalContent>
          <h3>Letra {selectedLetter}</h3>
          <LibrasCircle>
            <span className="libras-font">{selectedLetter}</span>
          </LibrasCircle>
          <p>Sinal em Libras</p>
          <button
            type="button"
            className="dactylology-modal-btn"
            onClick={() => {
              setModalVisible(false);
              navigate("/dactylology", {
                state: { word: selectedLetter || "" },
              });
            }}
          >
            Ver datilologia desta letra
          </button>
        </LibrasModalContent>
      </Modal>
    </MobileLayout>
  );
};

export default LetterSelection;
